import { render, staticRenderFns } from "./ReadAccuses.vue?vue&type=template&id=a6f95fb4&scoped=true"
import script from "./ReadAccuses.vue?vue&type=script&lang=js"
export * from "./ReadAccuses.vue?vue&type=script&lang=js"
import style0 from "./ReadAccuses.vue?vue&type=style&index=0&id=a6f95fb4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f95fb4",
  null
  
)

export default component.exports